import React from 'react';
import {
  LayoutDashboard,
  Cloud,
  Server,
  Database,
  Activity,
  AlertTriangle,
  FileText,
  Zap,
  Rocket,
  Code,
  Layers,
  GitBranch,
  Briefcase,
  UsersRound,
  UserRound,
  ClipboardCheck,
  Bell,
  BarChart3,
  Sparkles,
  Brain,
  GraduationCap,
  KeyRound,
  Plug,
  Puzzle,
  Boxes,
  Cable,
} from 'lucide-react';

export interface MenuItem {
  name: string;
  path: string;
  icon: React.ReactNode;
  page?: string;
}

export interface MenuGroup {
  title: string;
  items: MenuItem[];
}

export const menuStructure: (MenuItem | MenuGroup)[] = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: <LayoutDashboard className="w-5 h-5" />,
    page: 'dashboard',
  },
  {
    title: 'Cloud',
    items: [
      { name: 'Cloud Servers', path: '/instances', icon: <Cloud className="w-5 h-5" />, page: 'instances' },
      { name: 'OpenShift Clusters', path: '/openshift-clusters', icon: <Server className="w-5 h-5" />, page: 'openshift_clusters' },
      { name: 'Kubernetes Clusters', path: '/kubernetes-clusters', icon: <Boxes className="w-5 h-5" />, page: 'openshift_clusters' },
      { name: 'Container Instances', path: '/dev-instances', icon: <Code className="w-5 h-5" />, page: 'dev_instances' },
      { name: 'MAS Instances', path: '/mas-instances', icon: <Database className="w-5 h-5" />, page: 'mas_instances' },
      { name: 'Cluster Brokers', path: '/cluster-brokers', icon: <Cable className="w-5 h-5" />, page: 'openshift_clusters' },
    ],
  },
  {
    title: 'Support',
    items: [
      { name: 'Service Health', path: '/service-health', icon: <Activity className="w-5 h-5" />, page: 'service_health' },
      { name: 'Alerts and Alarms', path: '/alerts', icon: <AlertTriangle className="w-5 h-5" />, page: 'alerts' },
      { name: 'Service Reports', path: '/service-reports', icon: <FileText className="w-5 h-5" />, page: 'service_reports' },
    ],
  },
  {
    title: 'DevOps',
    items: [
      { name: 'Workflows', path: '/workflows', icon: <Zap className="w-5 h-5" />, page: 'workflows' },
      { name: 'CI/CD Flows', path: '/cicd', icon: <Rocket className="w-5 h-5" />, page: 'cicd' },
      { name: 'PR Instances', path: '/pr-instances', icon: <GitBranch className="w-5 h-5" />, page: 'pr_instances' },
      { name: 'Dev Images', path: '/dev-images', icon: <Layers className="w-5 h-5" />, page: 'dev_images' },
      { name: 'Approvals', path: '/approvals', icon: <ClipboardCheck className="w-5 h-5" />, page: 'approvals' },
    ],
  },
  {
    title: 'AI',
    items: [
      { name: 'AI Workspaces', path: '/admin/ai-config', icon: <Sparkles className="w-5 h-5" />, page: 'ai_config' },
      { name: 'Integrations', path: '/admin/integrations', icon: <Plug className="w-5 h-5" />, page: 'integrations' },
      { name: 'Plugins', path: '/admin/plugins', icon: <Puzzle className="w-5 h-5" />, page: 'plugins' },
      { name: 'AI Workflows', path: '/ai-workflows', icon: <Brain className="w-5 h-5" />, page: 'ai_workflows' },
      { name: 'AI Learning', path: '/ai-learning', icon: <GraduationCap className="w-5 h-5" />, page: 'ai_workflows' },
    ],
  },
  {
    title: 'Administration',
    items: [
      { name: 'Tenants', path: '/tenants', icon: <Briefcase className="w-5 h-5" />, page: 'tenants' },
      { name: 'User Groups', path: '/user-groups', icon: <UsersRound className="w-5 h-5" />, page: 'user_groups' },
      { name: 'Users', path: '/users', icon: <UserRound className="w-5 h-5" />, page: 'users' },
      { name: 'Cache Management', path: '/admin/cache', icon: <Database className="w-5 h-5" />, page: 'cache_management' },
      { name: 'Monitoring', path: '/monitoring', icon: <BarChart3 className="w-5 h-5" />, page: 'monitoring' },
      { name: 'Notifications', path: '/notifications', icon: <Bell className="w-5 h-5" />, page: 'notifications' },
      { name: 'Approvals Config', path: '/admin/approvals', icon: <ClipboardCheck className="w-5 h-5" />, page: 'approvals' },
      { name: 'Identity Providers', path: '/admin/identity-providers', icon: <KeyRound className="w-5 h-5" />, page: 'user_groups' },
    ],
  },
];

export const DOCUMENTATION_URL = 'https://docs.portal.maxiron.cloud';
